import { MouseEvent, useCallback, useState } from 'react';
import { theme } from '@vfit/shared/themes';
import { ContainerTopProduct, ImageDivider, ButtonSlide } from '@vfit/shared/atoms';
import { Fade } from 'react-awesome-reveal';
import { VfModal } from '@vfit/shared/components';
import { ActionTextType, ITextModal } from '@vfit/shared/models';
import { IText } from './text.models';
import { DisclaimerContainer, ModalContent, ModalTitle, ButtonContainer, TextConfig, TextDisclaimer, ModalTitleText, ModalContentText } from './text.style';
import { purify } from '@vfit/shared/themes';

const TextConfigContainer = ({onClickType, purifiedTextConfig}: {onClickType: (type: ActionTextType, description: string | undefined, title?: string | undefined) => void; purifiedTextConfig: string | undefined}) => {
  const handleClick = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      const element = e.target as HTMLDivElement;
      const dataAction = element.getAttribute('data-action') as ActionTextType;
      const dataDescription = element.getAttribute('data-desc') as ActionTextType;
      const dataTitle = element.getAttribute('data-title') as ActionTextType;
      if ((dataAction || dataDescription) && onClickType && dataAction in ActionTextType) {
        onClickType(ActionTextType[dataAction], dataDescription, dataTitle);
      }
    },
    [onClickType]
  );
  return <TextConfig onClick={handleClick} dangerouslySetInnerHTML={{ __html: purifiedTextConfig || '' }}  />
}

const Text = ({ textConfig, divider, disclaimer, textRef, actionText, actionClick }: IText) => {
  const [modal, setModal] = useState<ITextModal>({
    show: false,
  });
  const onClickTypeInText = (
    type: ActionTextType,
    description: string | undefined,
    title?: string
  ) => {
    if (description) {
      setModal({
        show: true,
        text: description || '',
        title: title || '',
        disableOrganizeText: true,
      });
    }
  };

  const resetModal = () => {
    setModal({
      show: false,
      text: '',
      title: '',
      disableOrganizeText: false,
    });
  };

  const [purifiedTextConfig] = purify([textConfig?.text || '']);
  const [purifiedTextDisclaimer] = purify([disclaimer || '']);
  const [purifiedModalTitle] = purify([modal.title || '']);
  const [purifiedModalText] = purify([modal.text || '']);
  
  return (
    <>
      <ContainerTopProduct ref={textRef}>
        <Fade direction="up" triggerOnce>
          <TextConfigContainer onClickType={onClickTypeInText} purifiedTextConfig={purifiedTextConfig} />
          {actionText && actionClick && (
            <ButtonContainer>
              <ButtonSlide
                label={actionText}
                onClick={actionClick}
                buttonColor={theme.colors.brand.primary}
                labelColor={theme.colors.text.inverse}
                hoverColor={theme.colors.brand.primaryHover}
                clickColor={theme.colors.brand.primaryActive}
                name="action_text"
              />
            </ButtonContainer>
          )}
          {disclaimer && (
            <DisclaimerContainer>
              <TextDisclaimer dangerouslySetInnerHTML={{ __html: purifiedTextDisclaimer || '' }}  />
            </DisclaimerContainer>
          )}
        </Fade>
      </ContainerTopProduct>
      {divider?.image && (
        <Fade direction="up" triggerOnce>
          <ImageDivider image={divider?.image} alt={divider.text || ''} />
        </Fade>
      )}
      <VfModal height={563} isOpen={modal.show} handleClose={resetModal} customFooter={undefined}>
        <>
          {modal.title && (
            <ModalTitle>  
              <ModalTitleText dangerouslySetInnerHTML={{ __html: purifiedModalTitle || '' }}  />
            </ModalTitle>
          )}
          {modal.text && (
            <ModalContent>
              <ModalContentText dangerouslySetInnerHTML={{ __html: purifiedModalText || '' }}  />
            </ModalContent>
          )}
        </>
      </VfModal>
    </>
  );
};

export default Text;
